import { Back, TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { getGameSize } from '../../../../Config/Levels';
import { ShareableMoments } from '../../../../SDK/SDKmessages';
import { ShareHelpers } from '../../../../Utils/ShareHelpers';
import { ShareableOverlay } from './ShareableOverlay';
import { Animation } from '../../../Animations/Animation';

export class MapCompleteShareableOverlay extends ShareableOverlay {
    private group: Sprite;
    private endY: number = 0;
    private groupWidth: number = 0;
    private groupHeight: number = 0;
    private played: boolean = false;

    constructor(mapId: string) {
        super(ShareableMoments.NEW_MAP, mapId);

        this.setUpMapShare(mapId).then(() => {
            this.tweenIn();
        });
        /* .catch(err => {
                console.log(' error setting up map share popup: ' + err);
            }); */
    }

    public tweenIn() {
        super.tweenIn();

        if (!this.group || this.played) {
            return;
        }

        this.played = true;
        const a = new PIXI.Sprite(PIXI.utils.TextureCache['fx/Jackpot_flash']);
        const b = new PIXI.Sprite(PIXI.utils.TextureCache['fx/Jackpot_flash']);
        const c = new PIXI.Sprite(PIXI.utils.TextureCache['fx/Jackpot_flash']);

        const positions = [
            { x: this.group.x + this.groupWidth * 0.1, y: this.endY + this.groupHeight * 0.1 },
            { x: this.group.x + this.groupWidth, y: this.endY + this.groupHeight * 0.7 },
            { x: this.group.x + this.groupWidth * 0.3, y: this.endY + this.groupHeight },
        ];
        const flashes = [a, b, c];

        flashes.forEach((f, index) => {
            f.alpha = 0;
            f.anchor.set(0.5);
            f.scale.set(0);
            f.x = positions[index].x;
            f.y = positions[index].y;
            this.addChild(f);
        });

        const animation = new Animation({});
        animation.addDelay(100),
            animation.add(TweenMax.to(flashes[0], 0.3, { alpha: 1, repeat: 1, yoyo: true }));
        animation.addToLast(
            TweenMax.to(flashes[0].scale, 0.3, { x: 1, y: 1, repeat: 1, yoyo: true })
        );
        animation.addToLast(
            TweenMax.to(flashes[1], 0.3, { alpha: 1, repeat: 1, delay: 0.1, yoyo: true })
        );
        animation.addToLast(
            TweenMax.to(flashes[1].scale, 0.3, { x: 1, y: 1, delay: 0.1, repeat: 1, yoyo: true })
        );
        animation.addToLast(
            TweenMax.to(flashes[2], 0.3, { alpha: 1, delay: 0.4, repeat: 1, yoyo: true })
        );
        animation.addToLast(
            TweenMax.to(flashes[2].scale, 0.3, { x: 1, y: 1, delay: 0.4, repeat: 1, yoyo: true })
        );
        animation.play();

        TweenMax.to(this.group, 0.5, { y: this.endY, ease: Back.easeOut });
    }

    private async setUpMapShare(mapId: string) {
        const group = new PIXI.Sprite();

        const polaroid = await ShareHelpers.getMapCompletePolaroid(mapId);
        group.x = (getGameSize().gameWidth - polaroid[1].width) * 0.5;
        group.y = getGameSize().gameHeight + 50;
        polaroid.forEach(x => group.addChild(x));
        this.addChild(group);

        this.groupWidth = polaroid[1].width;
        this.groupHeight = polaroid[1].height;
        this.group = group;
        this.endY = (getGameSize().gameHeight - polaroid[1].height) * 0.5 - 50;
    }
}
